import { useChecklistContext } from '../../../../contexts';
import { ChecklistSection } from '../../ChecklistPage';
import { PaddedGenericSection } from '../GenericSection';

export const AdditionalSupportRefName = 'additional-support';

export default function AdditionalSupportSection() {
  const { checklist } = useChecklistContext();

  const {
    additionalSupport,
  } = checklist ?? {};

  return (
    <PaddedGenericSection
      refName={AdditionalSupportRefName}
      section={ChecklistSection.ADDITIONAL_SUPPORT}
      checklistItem={additionalSupport}
    >
      <p>level 0</p>
    </PaddedGenericSection>
  );
}
